import { Navigate, type NavigateProps } from 'react-router-dom'
import { useLocalizedPath } from '@/hooks/useLocalizedPath'

/** `<Navigate>` whose string `to` is prefixed with the current language. */
export default function LocalizedNavigate({ to, ...props }: NavigateProps) {
  const lp = useLocalizedPath()
  return <Navigate to={typeof to === 'string' ? lp(to) : to} {...props} />
}
